<template>
  <div class="container">
    <Card>
      <v-form
        ref="form"
        v-model="form_validate_status"
        v-on:submit.prevent="validate"
      >
        <v-container>
          <PrenameCard v-model="applicantPrenameId" v-if="true" />

          <NameTHCard
            v-model="applicantNameTH"
            v-bind:textLabelNameTh="$t('info_card.name_th')"
            v-bind:textPlaceholderNameTh="$t('info_card.name_th')"
            v-bind:textHintNameTh="$t('info_card.name_th_hint')"
            v-bind:textLabelSurenameTh="$t('info_card.surname_th')"
            v-bind:textPlaceholderSurenameTh="$t('info_card.surname_th')"
            v-bind:textHintSurenameTh="$t('info_card.surname_th_hint')"
          />
          <NameENCard v-model="applicantNameEN" />
        </v-container>
        <v-btn v-on:click="validate()"> check </v-btn>
        <v-btn v-on:click="clear()"> clear </v-btn>
      </v-form>
    </Card>
  </div>
</template>

<script>
import Card from "../components/info_cards/Card";
import PrenameCard from "../components/info_cards/Prename";
import NameTHCard from "../components/info_cards/NameTH";
import NameENCard from "../components/info_cards/NameEN";

import { createHelpers } from "vuex-map-fields";

const { mapFields: mapApplicantInfoFields } = createHelpers({
  getterType: "applicantInfo/getField",
  mutationType: "applicantInfo/updateField",
});

export default {
  components: {
    Card,
    PrenameCard,
    NameTHCard,
    NameENCard,
  },
  data() {
    return {
      form_validate_status: null,
    };
  },
  computed: {
    ...mapApplicantInfoFields({
      applicantPrenameId: "prenameId",
    }),
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    clear() {
      this.$refs.form.reset();
    },
  },
  mounted: function() {
    this.$store.dispatch("ref/getPrenames");
  },
};
</script>
